export const handlePaste = (event: React.ClipboardEvent<HTMLDivElement>) => {
  event.preventDefault();

  const pastedText = event.clipboardData.getData('text');

  const selection = window.getSelection();
  if (selection && selection.rangeCount > 0) {
    const range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(document.createTextNode(pastedText));
    selection.removeAllRanges();
  }
};
